"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    root: {
      userSelect: 'none',
      touchAction: 'none',
      pointerEvents: 'none',
      opacity: 0.75,
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 'bold',
      fontSize: '1.25em',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'right',
      alignSelf: 'flex-end',
      marginTop: 0,
      textRendering: 'optimizeLegibility',
      '&.dark': {
        color: theme.palette.common.black,
        textShadow: "0.05em 0.05em 0 rgba(255,255,255,0.8), \n                -0.05em -0.05em 0 rgba(255,255,255,0.8), \n                0.05em -0.05em 0 rgba(255,255,255,0.8), \n                -0.05em 0.05em 0 rgba(255,255,255,0.8),\n                0.05em 0.05em 0 rgba(255,255,255,0.8)\n            "
      },
      '&.light': {
        color: theme.palette.common.white,
        textShadow: "0.05em 0.1em 0.15em rgba(0,0,0,0.5), \n            -0.05em -0.05em 0.1em rgba(0,0,0,0.5), \n            0.05em -0.05em 0.1em rgba(0,0,0,0.5), \n            -0.05em 0.05em 0.1em rgba(0,0,0,0.25), \n            0.05em 0.05em 0.5em rgba(0,0,0,0.2)"
      }
    },
    circle: {
      width: '1.5em',
      height: '1.5em',
      borderRadius: '1.5em',
      marginRight: '0.1em',
      '&.dark': {
        backgroundColor: theme.palette.common.black
      },
      '&.light': {
        backgroundColor: theme.palette.common.white
      },
      boxShadow: "rgba(0, 0, 0, 0.5) 0 0.1em 0.1em 0, \n        rgba(0, 0, 0, 0.25) 0 0.05em 0.05em 0, \n        rgba(0, 0, 0, 0.2) 0 0.05em 0.05em -0.05em"
    },
    trademark: {
      fontFamily: '\'Open Sans\', sans-serif',
      fontWeight: 'bold',
      fontSize: '0.5em',
      color: 'inherit',
      alignSelf: 'flex-start'
    }
  };
});

var MyGlobeIcon = function MyGlobeIcon(_ref) {
  var type = _ref.type;
  var classes = useStyles();
  var brandingClasses = (0, _classnames["default"])(classes.root, {
    'light': type === 'light',
    'dark': type === 'dark'
  });
  var circleClasses = (0, _classnames["default"])(classes.circle, {
    'light': type === 'light',
    'dark': type === 'dark'
  });
  return _react["default"].createElement("div", {
    className: brandingClasses
  }, _react["default"].createElement("div", {
    className: circleClasses
  }), _react["default"].createElement("span", null, "MYGLOBE"), _react["default"].createElement("span", {
    className: classes.trademark
  }, "TM"));
};

MyGlobeIcon.propTypes = {
  type: _propTypes["default"].oneOf(['light', 'dark'])
};
MyGlobeIcon.defaultProps = {
  type: 'light'
};
var _default = MyGlobeIcon;
exports["default"] = _default;